import { Input } from '@aigc/antd';
import type { Nullish } from '@aigc/types';
import type { Lens } from '@hookform/lenses';
import { Mentions, type GetProp, type UploadFile } from 'antd';
import { FormControl } from '../../../components/form-control';
import type { GenerationType, VideoModelCode } from '../model-spec';
import { PromptTooltip } from './prompt-tooltip';

export const PromptControl = (props: {
  generationType?: GenerationType;
  lens: Lens<Nullish<string>>;
  images?: UploadFile[];
  asset_ids?: string[];
  modelLens?: Lens<VideoModelCode>;
  autoSize?: GetProp<typeof Input.TextArea, 'autoSize'>;
}) => {
  const enableReference = props.generationType === 'reference';

  return (
    <FormControl
      {...props.lens.interop()}
      label={
        <div className="flex items-center">
          <div className="min-w-0 flex-none">提示词</div>
          {enableReference && (
            <PromptTooltip lens={props.modelLens}></PromptTooltip>
          )}
        </div>
      }
      required
      layout="vertical"
      rootClassName="col-span-4"
      render={({ field }) => {
        if (enableReference) {
          let imageIndex = 0;
          let videoIndex = 0;

          return (
            <Mentions
              {...field}
              value={field.value ?? ''}
              options={[
                ...(props.images?.map((item) => {
                  if (item.name.endsWith('.mp4')) {
                    videoIndex = videoIndex + 1;

                    return {
                      label: `视频${videoIndex}(${item.name})`,
                      value: `视频${videoIndex}`,
                      disabled: item.status !== 'done',
                    };
                  } else {
                    imageIndex = imageIndex + 1;

                    return {
                      label: `图片${imageIndex}(${item.name})`,
                      value: `图片${imageIndex}`,
                      disabled: item.status !== 'done',
                    };
                  }
                }) ?? []),
                ...(props.asset_ids?.map((_, index) => ({
                  label: `人像${index + 1}`,
                  value: `人像${index + 1}`,
                })) ?? []),
              ]}
              autoSize={props.autoSize ?? { minRows: 12 }}
              placeholder="请输入视频生成提示词，部分模型可以通过 @ 引用参考图"
            ></Mentions>
          );
        }

        return (
          <Input.TextArea
            {...field}
            value={field.value ?? ''}
            autoSize={props.autoSize ?? { minRows: 12 }}
            placeholder="请输入视频生成提示词"
          ></Input.TextArea>
        );
      }}
    ></FormControl>
  );
};
